module.exports = __webpack_public_path__ + "static/media/icon-dash-family.5cac98be.png";